import React from "react";
import { logoutLink, navSections } from "../Links";
import { LayoutDashboard, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import Images from "../Images";
import tw from "tailwind-styled-components";

const MobileSidebar = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 z-50 bg-black/50"
      />

      {/* Sidebar */}
      <motion.div
        initial={{ x: "-100%" }}
        animate={{ x: 0 }}
        exit={{ x: "-100%" }}
        transition={{ 
          type: "spring",
          damping: 25,
          stiffness: 200
        }}
        className="fixed inset-y-0 left-0 z-50 w-[280px] bg-white shadow-xl"
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b">
            <img src={Images.logo} alt="Dealboxx - Logo" className="h-8" />
            <button 
              onClick={onClose}
              className="p-2 rounded-full transition-colors hover:bg-gray-100"
            >
              <X className="w-6 h-6 text-gray-800" />
            </button>
          </div>
          
          {/* Scrollable Navigation */}
          <nav className="overflow-y-auto flex-1">
            <div className="px-4 py-2 h-full">
              <ul className="space-y-2">
              <li>
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `group flex items-center w-full gap-2 rounded-md p-4 font-semibold text-sm transition duration-300 ease-in-out cursor-pointer ${
                  isActive ? "bg-[#FF6C6C] text-white" : "text-gray-800 hover:bg-[#FF6C6C] hover:text-white"
                }`
              }
            >
              <LayoutDashboard className="transition duration-300 group-hover:text-white" />
              <p className="text-lg font-semibold transition duration-300">
                Dashboard
              </p>
            </NavLink>
          </li>
          {navSections.map((section) => (
            <LinkGroup key={section.id} title={section.title} links={section.links} onClose={onClose} />
          ))}
          <LinkGroup title="Account" links={[logoutLink]} onClose={onClose} />
              </ul>
            </div>
          </nav>
        </div>
      </motion.div>
    </>
  );
};

const LinkGroup = ({ title, links, onClose }) => (
  <div className="flex flex-col">
    <LinkGroupTitle>{title}</LinkGroupTitle>
    {links.map((link, index) => (
      <li key={index}>
        <NavLink
          to={`${link.link}`}
          end={link.link === "/deals"}
          className={({ isActive }) =>
            `group flex items-center w-full gap-2 rounded-md p-3 font-semibold text-[12px] transition duration-300 ease-in-out cursor-pointer ${
              isActive ? "bg-[#FF6C6C] text-white" : "text-gray-700 hover:bg-[#FF6C6C] hover:text-white"
            }`
          }
          onClick={onClose}
        >
          <link.icon className="h-[18px] w-[18px] shrink-0" aria-hidden="true" />
          <p className="text-[14px] font-semibold transition duration-300">
            {link.name}
          </p>
        </NavLink>
      </li>
    ))}
  </div>
);

const LinkGroupTitle = tw.p`text-sm font-bold text-black mt-3 p-3 w-full`;

export default MobileSidebar;
